import React from 'react'

const NokAir = () => {
  return (
    <div>NokAir</div>
  )
}

export default NokAir